<div class="spinner">
	<div
		[class]="type + ' ' + type + '1'"
		[ngStyle]="{ backgroundColor: this.color, width: this.size + 'px', height: this.size + 'px' }"></div>

	<div
		[class]="type + ' ' + type + '2'"
		[ngStyle]="{ backgroundColor: this.color, width: this.size + 'px', height: this.size + 'px' }"></div>

	<div
		[class]="type + ' ' + type + '3'"
		[ngStyle]="{ backgroundColor: this.color, width: this.size + 'px', height: this.size + 'px' }"></div>
</div>
